define([
	"canvas/widgets/interfaces/model/enumerations/PlaceholderTextFormat",
	"./_PlaceholderTextFormat",
	"./PluginFactory"
], function({PlaceholderTextFormat}, _PlaceholderTextFormat, PluginFactory) {

	return PluginFactory.declare(_PlaceholderTextFormat, {
		"class": "csi-button-toggle csi-toggle-group-first",
		enumValue: PlaceholderTextFormat.ALL,
		label: "All",
		pluginName: "PlaceholderTextAll",
		showLabel: true,
		title: "CanvasLabels",

		/**
		 * @override
		 * Disable plugin if this is rich-text placeholder
		 */
		 enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set("checked", this.enumValue === this.editor.canvasApp.pageHelper.getPlaceholderTextFormat());
			return !this.editor.isRichTextPlaceholderSelected(shapes);
		},
	});
});
